import icon from './components/icon.vue'
import iotn from './components/iotn.vue'

const routes = [
    { path: '/', component: icon, props: {iconType: 'pre-icon'} },
    { path: '/pre-icon', component: icon, props: {iconType: 'pre-icon'} },
    { path: '/post-icon', component: icon, props: {iconType: 'post-icon'} },
    { path: '/iotn', component: iotn}
]

export default routes;
